import React from 'react'

import { useAppDispatch } from 'hooks/reduxHooks'
import { accountAccessShowLogin } from 'actions/UiActions'
import styled from 'styled-components'
import { rem } from 'polished'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import TextLink from 'components/Luxkit/TextLink'
import TextButton from 'components/Luxkit/Button/TextButton'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Heading from 'components/Luxkit/Typography/Heading'
import BodyText from 'components/Luxkit/Typography/BodyText'

const HeroButton = styled.div`
  text-align: center;
  margin-top: ${rem(16)};
`

const SecondaryText = styled.div`
  text-align: center;
  margin-top: ${rem(16)};
`

const InnerSection = styled(LayoutContainer).attrs<any>({
  size: 'md',
})`
  padding: ${rem(32)} ${rem(40)};

  ${mediaQueryUp.desktop} {
    padding: ${rem(64)} ${rem(32)};
  }
`

interface Props {
  hash: string;
  headerText?: string;
  secondaryText?: string;
}

function Login({ headerText, secondaryText, hash }: Props) {
  const dispatch = useAppDispatch()
  return <Pane id={hash}>
    <PaneBody>
      <InnerSection>
        {headerText && <Heading variant="heading5" align="center">
          {headerText}
        </Heading>}
        <Heading variant="heading3" align="center">
          Sign up to become a Luxury Escapes member today!
        </Heading>
        <SecondaryText>
          <BodyText variant="large" weight="bold" as="span">Already a member?</BodyText>
          {secondaryText && <>
            &nbsp;
            <BodyText variant="large" as="span">{secondaryText}</BodyText>
          </>}
        </SecondaryText>
        <HeroButton>
          <TextButton kind="primary" onClick={() => dispatch(accountAccessShowLogin())}>
            Log in to my account
          </TextButton>
        </HeroButton>
        <HeroButton>
          <TextLink onClick={() => dispatch(accountAccessShowLogin())}>
            or create an account
          </TextLink>
        </HeroButton>
      </InnerSection>
    </PaneBody>
  </Pane>
}

export default Login
